import { render, staticRenderFns } from "./WapFileDetails.vue?vue&type=template&id=1aa1736f&scoped=true&"
import script from "./WapFileDetails.vue?vue&type=script&lang=js&"
export * from "./WapFileDetails.vue?vue&type=script&lang=js&"
import style0 from "./WapFileDetails.vue?vue&type=style&index=0&id=1aa1736f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa1736f",
  null
  
)

export default component.exports